import { StyleSpecification } from "@iventis/mapbox-gl";
import { BasemapDataStore } from "./basemap-data-store";

export type Sitemap2d = StyleSpecification & { expiry: string };

export class Sitemap2dDataStore extends BasemapDataStore<Sitemap2d> {
    protected async getBasemapApiCall(sitemapId: string): Promise<Sitemap2d> {
        const sitemapAsset = await this.getBasemapAsset(sitemapId);
        const sitemapRequest = await fetch(sitemapAsset.url);
        const sitemapJson = (await sitemapRequest.json()) as Sitemap2d;

        for (const source of Object.values(sitemapJson.sources ?? {})) {
            if (source.type === "vector" || source.type === "raster") {
                source.tiles = source.tiles.map((tile) => `${tile}?${sitemapAsset.signature}&assetVersion=${sitemapAsset.updatedAt.toISOString()}`);
            }
        }

        return { ...sitemapJson, expiry: sitemapAsset.expiry };
    }
}
